import PropTypes from "prop-types";
//Styles
import styled from "styled-components";

const VerticalList = styled.ul`
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  li {
    line-height: ${props => props.lineHeight};
    list-style-type: ${props => props.listStyleType};

    padding-top: ${props => props.listPaddingTop};
    padding-bottom: ${props => props.listPaddingBottom};

    :last-child {
      margin-bottom: ${props => props.marginBottom};
    }
  }
`;

VerticalList.defaultProps = {
  marginTop: "0",
  marginBottom: "0",
  lineHeight: "normal",
  listStyleType: "none"
};

VerticalList.propTypes = {
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  lineHeight: PropTypes.string,
  listPaddingTop: PropTypes.string,
  listPaddingBottom: PropTypes.string
};

export default VerticalList;
